import { play, playOutline } from 'ionicons/icons';
import { ReactElement } from 'react';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { FlowItem } from '../../../model/flow.types';
import {
  FlowItemBaseAction,
  FlowItemBaseActionCommonProps,
} from './flow-item-base-action';

interface FlowItemStartAtActionProps extends FlowItemBaseActionCommonProps {
  item?: FlowItem;
  onSetStartChange: () => void;
  startAtId?: string;
}

const FlowItemStartAtAction = (
  props: FlowItemStartAtActionProps
): ReactElement => {
  const { item, onSetStartChange, startAtId, disabled } = props;

  const isStartingAtThisId = item?.id && startAtId === item?.id ? true : false;

  return (
    <FlowItemBaseAction
      icon={isStartingAtThisId ? play : playOutline}
      color={isStartingAtThisId ? 'var(--ion-color-success)' : undefined}
      label={
        isStartingAtThisId
          ? getLocalizedText('common:cancel')
          : getLocalizedText('common:start_here')
      }
      onClick={() => onSetStartChange()}
      disabled={disabled}
    />
  );
};

export { FlowItemStartAtAction };
